import * as React from 'react'

type Size = "tiny" | "medium"

const sizeToClassName = (size: Size) => {
	switch (size) {
		case "tiny": return "sbTextInputTiny"
		case "medium": return "sbTextInputMedium"
	}
}

export interface Props extends React.Props<Input> {
	name?: string
	value: string
	onChange?: (value:string) => void
	size?: Size
	disabled?: boolean
	invalid?: boolean
	maxlength?: number
	numeric?: NumericProps
	style?: React.CSSProperties
}

export type NumericProps = {
	step?: number
	min?: number
	max?: number
}

interface State {
	isFocused: boolean
}

export class Input extends React.Component<Props, State> {
	constructor(p?:Props, context?:any) {
		super(p, context)
		this.state = {isFocused: false}
	}

	render() {
		const classNames = [this.state.isFocused ? "sbTextInputOn" : "sbTextInputOff", sizeToClassName(this.props.size || "medium")]
		const style = Object.assign(this.props.invalid ? {border: "solid red 2px"} : {}, this.props.style || {})
		const numericProps = this.props.numeric ? {...this.props.numeric, type: 'number'} : {}

		return <input
			{...numericProps}
			className={classNames.join(" ")}
			disabled={this.props.disabled}
			onChange={(event:React.FormEvent<HTMLInputElement>) => {
				event.stopPropagation()
				if (this.props.onChange) {
					this.props.onChange(event.currentTarget.value)
				}
			}}
			onFocus={() => this.setState({isFocused: true})}
			onBlur={() => this.setState({isFocused: false})}
			value={this.props.value}
			name={this.props.name}
			maxLength={this.props.maxlength}
			style={style}
		/>
	}
}

export type AlwaysPostProps = {
	name: string
	value: string|number|string[]|undefined
}

export const AlwaysPost = (props: AlwaysPostProps) => {
	return <input
		hidden={true}
		readOnly={true}
		name={props.name}
		value={props.value}
	/>
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/input.tsx